import { has } from 'lodash'
import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import { setCompanyDiseases } from 'src/store/modules/actionCreators'
import { companySelector } from 'src/store/modules/company/selectors'

import api from 'src/services/@core/API'
import { makeOneLevelArray } from 'src/utils/Array'
// utils
import { addAllValue } from 'src/utils/v5/DataTrees'

/* --------- reducer --------- */
const initialState = []
export default handleActions(
  {
    [setCompanyDiseases](state, { payload = [] }) {
      return [...payload]
    }
  },
  initialState
)

/* --------- thunks --------- */
export const getCompanyDiseases = (query) => (dispatch) =>
  api.getCompanyDiseases(query).then(
    (diseases) => dispatch(setCompanyDiseases(diseases.items)),
    (err) => Promise.reject(err)
  )

/* --------- selectors --------- */
export const companyDiseasesSelector = createSelector(
  companySelector,
  (company) => company.diseases
)

export const companyDiseasesWithAll$ = createSelector(
  companyDiseasesSelector,
  (diseases = []) =>
    addAllValue({ list: diseases.filter((e) => !e?.isDeleted) })
)

export const companyPrimaryDiseasesSelector = createSelector(
  companyDiseasesSelector,
  (diseases) => diseases
)

export const companyDiseasesClinicalPathway$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    diseases
      .filter(
        ({ isVisibleForClinicalPathway = true }) => isVisibleForClinicalPathway
      )
      .map((item) =>
        !has(item, 'children')
          ? item
          : {
              ...item,
              children: item.children.filter(
                ({ isVisibleForClinicalPathway = true }) =>
                  isVisibleForClinicalPathway
              )
            }
      )
)

export const companyDiseasesEnrollmentProgram$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    makeOneLevelArray(diseases).filter(
      ({ isVisibleForEnrollment = false, isDeleted }) =>
        !isDeleted && isVisibleForEnrollment
    )
)

export const companyChildrenDiseasesSelector = createSelector(
  companyDiseasesSelector,
  (diseases) => diseases.reduce((acc, el) => [...acc, ...el.children], [])
)

export const companyDiseasesDropdown$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    diseases
      .filter((item) => !item.isDeleted)
      .map((item, key) => ({
        ...item,
        key,
        label: item.name,
        title: item.name,
        value: item.uuid
      }))
)
